<template>
  <RouterView v-slot="{ Component, route }" v-bind="{ ...props }">
    <slot v-bind="{ Component: getComponent(Component, route), route }" />
  </RouterView>
</template>

<script setup>
import {
  inject,
  provide,
  defineProps,
  getCurrentInstance,
  watchEffect,
  reactive,
  toRaw,
} from "vue";
import { RouterView, useRouter } from "vue-router";

/**
 * FIXME
 * "router-view + keep-alive + 嵌套路由, 有bug，需要使用这个组件来解决
 * issue: keep-alive component in nested route result in child route mounted twice
 * @see https://github.com/vuejs/router/issues/626#ref-issue-918160175
 */

const props = defineProps({
  ...RouterView.props,
  isEnabled: {
    type: Boolean,
    default: true,
  },
});

const router = useRouter();
const parentRouterView = inject("parentRouterView", null);

const currentRouterViewDetails = reactive({});
watchEffect(() => {
  currentRouterViewDetails.depth = (parentRouterView?.depth ?? -1) + 1;
  currentRouterViewDetails.componentTypeName = getComponentTypeName(
    getCurrentInstance().parent
  );
  currentRouterViewDetails.componentType = getComponentType(
    getCurrentInstance().parent
  );
  currentRouterViewDetails.routeConfig = router
    .getRoutes()
    .find(
      ({ components }) =>
        components?.default === toRaw(currentRouterViewDetails.componentType)
    );
});

provide("parentRouterView", currentRouterViewDetails);

function getComponent(Component, route) {
  if (!props.isEnabled || !Component) {
    return Component;
  }
  const matchedRoutedAtDepth = route.matched[currentRouterViewDetails.depth];
  return matchedRoutedAtDepth.name ===
    currentRouterViewDetails.routeConfig?.name
    ? Component
    : null;
}

function getComponentTypeName(Component) {
  return Component.type.__name ?? Component.type.name;
}

function getComponentType(Component) {
  return Component.type;
}
</script>
